import { ChartFrequency, getCurrentUserCommunicationAccountOwnerId } from 'wisestep-api';

const getFrequencyForAppliedDateRange = (fromDate: string, toDate: string) => {
  const differenceInDays =
    (new Date(toDate).getTime() - new Date(fromDate).getTime()) / (1000 * 3600 * 24);
  if (differenceInDays <= 1) return ChartFrequency.HOURS;
  if (1 < differenceInDays && differenceInDays <= 7) return ChartFrequency.DAILY;
  if (7 < differenceInDays && differenceInDays <= 30) return ChartFrequency.WEEKLY;
  if (30 < differenceInDays && differenceInDays <= 120) return ChartFrequency.MONTHLY;
  if (120 < differenceInDays) return ChartFrequency.QUARTERLY;
  return ChartFrequency.DAILY;
};
export default getFrequencyForAppliedDateRange;

export const fetchZoomAccountOwner = async () => {
  const { data } = await getCurrentUserCommunicationAccountOwnerId();
  localStorage.setItem('zoomAccountOwnerId', data?.owners?.[0]);
  return data?.owners?.[0];
};
